var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.38999 0.407051C0.639775 0.15709 0.978512 0.0166691 1.33171 0.0166691C1.68491 0.0166691 2.02364 0.15709 2.27343 0.407051L7.99167 6.13105L13.7099 0.407051C13.8328 0.279704 13.9798 0.178128 14.1423 0.108249C14.3048 0.0383705 14.4796 0.00158876 14.6564 5.03427e-05C14.8333 -0.00148808 15.0087 0.0322472 15.1724 0.0992884C15.3361 0.16633 15.4848 0.265334 15.6099 0.390524C15.7349 0.515714 15.8338 0.664584 15.9008 0.828446C15.9678 0.992307 16.0015 1.16788 15.9999 1.34492C15.9984 1.52196 15.9617 1.69692 15.8919 1.85959C15.8221 2.02226 15.7206 2.16939 15.5934 2.29238L9.87511 8.01638L15.5934 13.7404C15.836 13.9919 15.9702 14.3287 15.9672 14.6783C15.9642 15.0278 15.8241 15.3623 15.5771 15.6095C15.3302 15.8567 14.9961 15.9969 14.6468 15.9999C14.2976 16.003 13.9611 15.8686 13.7099 15.6257L7.99167 9.90172L2.27343 15.6257C2.02221 15.8686 1.68575 16.003 1.3365 15.9999C0.987258 15.9969 0.653177 15.8567 0.406215 15.6095C0.159253 15.3623 0.0191681 15.0278 0.0161333 14.6783C0.0130984 14.3287 0.147356 13.9919 0.38999 13.7404L6.10824 8.01638L0.38999 2.29238C0.14028 2.04235 0 1.70327 0 1.34972C0 0.996165 0.14028 0.657088 0.38999 0.407051Z",
    fill: "#33383D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close_button.564b2cf1ffb192fcffff197498672937.svg";
export { ForwardRef as ReactComponent };